import Czesci from '@/views/Czesci.vue'
import Index from '@/views/Index.vue'
import NotFound from '@/views/NotFound.vue'
import Produkt from '@/views/Produkt.vue'
import Produkty from '@/views/Produkty.vue'
import ProduktyList from '@/views/ProduktyList.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  /** backward compatibility routes */
  {
    path: '/produkty/1001/:description',
    redirect: '/produkty/1/:description'
  },
  {
    path: '/produkty/1002/:description',
    redirect: '/produkty/2/:description'
  },
  {
    path: '/produkty/1003/:description',
    redirect: '/produkty/3/:description'
  },
  {
    path: '/produkty/1004/:description',
    redirect: '/produkty/4/:description'
  },
  {
    path: '/produkty/1006/:description',
    redirect: '/produkty/6/:description'
  },
  /** App routes */
  {
    path: '/',
    name: 'Home',
    component: Index
  },
  {
    path: '/produkty.html',
    name: 'Produkty',
    component: Produkty
  },
  {
    path: '/produkty/:categoryId/:title?',
    name: 'ProduktyList',
    component: ProduktyList,
  },
  {
    path: '/produkt/:productId/:title?',
    name: 'Produkt',
    component: Produkt
  },
  {
    path: '/czesci-akcesoria/:pageId/:title',
    name: 'Czesci',
    component: Czesci
  },
  {
    path: '/kontakt.html',
    name: 'Kontakt',
    component: () => import(/* webpackChunkName: "about" */ '../views/Kontakt.vue')
  },
  {
    path: '/nota-prawna.html',
    name: 'NotaPrawna',
    component: () => import(/* webpackChunkName: "about" */ '../views/Legal.vue')
  },
  {
    path: '/polityka-cookie.html',
    name: 'NotaPrawna',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cookie.vue')
  },
  {
    path: '/firma.html',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  /** ErrorHandling */
  { path: '/not-found-404', component: NotFound },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => {
    return { x: 0, y: 0 }
  },
  routes
})

const DEFAULT_TITLE = 'Raveco - Profesjonalne wyposażenie sklepów i gastronomii'

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.params.title ? `Raveco -  ${to.params.title}` : DEFAULT_TITLE
  });
});

export default router
